













import Vue from 'vue';
import { get } from 'vuex-pathify';

import { Question } from '@/models/configurator/question';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'QuestionList',

  data: () => ({
    questionHeaders: [
      {
        text: '',
        sortable: false,
        align: 'start',
        width: '20px',
        value: 'data-table-filetype'
      },
      {
        text: 'Text',
        align: 'start',
        sortable: false,
        value: 'text',
        width: '150px',
        style: {
          'max-width': '100px'
        }
      },

      {
        text: 'Type',
        style: {
          'max-width': '100px'
        },
        value: 'type'
      },

      { text: 'Module', value: 'module' }
    ]
  }),

  computed: {
    questions: get<Question[]>('configuratorQuestion/questions')
  },

  mounted() {
    this.fetchQuestions({ module: 1 });
  },

  methods: {
    ...mapActions('configuratorQuestion', ['fetchQuestions'])
  }
});
